import { UserClaims } from '@okta/okta-auth-js';
import { Record } from 'immutable';

export class AuthStoreState extends Record({
  token: null as string | null,
  oktaClaims: null as UserClaims | null,
}) {
  public token: string | null;
  public oktaClaims: UserClaims | null;
}
